






























































































































































































































































import { Component, Vue } from "vue-property-decorator";
import axios from "axios";
@Component({})
export default class Home extends Vue {
  private servicio1() {
    this.$router.push({ name: "Erradicacion" }).catch(err => {});
  }

  private servicio2() {
    this.$router.push({ name: "Bateas" }).catch(err => {});
  }

  private servicio3() {
    this.$router.push({ name: "Recoleccion" }).catch(err => {});
  }

  private servicio4() {
    this.$router.push({ name: "Moviles" }).catch(err => {});
  }

  private routerGo(name: string, opcion: string) {
    if (name && name != "") {
      if (this.$router.currentRoute.name == name) {
        this.$router.go(0);
      } else {
        this.$router
          .push({ name: name, params: { nombre: opcion } })
          .catch(err => {
            console.log(err);
          });
      }
    }
  }

  private toLink(item: any, target: any) {
    if (item && item != "") {
      window.open(item, target);
    } else {
      return;
    }
  }
}
